export default __webpack_public_path__ + "static/media/world.44471ef6.svg";